var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleChrome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M255.616 6.06849C255.616 6.06849 402.155 -0.508286 479.844 146.784H243.148C243.148 146.784 198.48 145.346 160.321 199.536C149.36 222.28 137.577 245.71 150.799 291.885C131.753 259.617 49.6807 116.709 49.6807 116.709C49.6807 116.709 107.57 11.8917 255.616 6.06849V6.06849V6.06849Z",
    fill: "#EF3F36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.239 379.986C472.239 379.986 404.622 510.22 238.284 503.78C258.836 468.225 356.666 298.804 356.666 298.804C356.666 298.804 380.301 260.85 352.418 200.7C338.237 179.805 323.782 157.951 277.196 146.305C314.67 145.962 479.432 146.305 479.432 146.305C479.432 146.305 541.158 248.862 472.239 379.986V379.986V379.986Z",
    fill: "#FCD900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.021 381.014C40.021 381.014 -38.969 257.356 49.8176 116.504C70.3016 152.059 168.131 321.48 168.131 321.48C168.131 321.48 189.232 360.941 255.205 366.833C280.348 364.983 306.518 363.407 339.95 328.948C321.521 361.557 238.832 504.054 238.832 504.054C238.832 504.054 119.079 506.247 40.021 381.014V381.014V381.014Z",
    fill: "#61BC5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.215 505.014L271.51 366.079C271.51 366.079 308.093 363.202 338.785 329.564C319.74 363.065 238.215 505.014 238.215 505.014V505.014V505.014Z",
    fill: "#5AB055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.085 257.082C144.085 195.836 193.753 146.168 255 146.168C316.246 146.168 365.914 195.836 365.914 257.082C365.914 318.329 316.246 367.997 255 367.997C193.753 367.929 144.085 318.329 144.085 257.082V257.082V257.082Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.65 257.082C162.65 206.112 203.961 164.733 254.999 164.733C305.97 164.733 347.348 206.044 347.348 257.082C347.348 308.053 306.038 349.432 254.999 349.432C204.029 349.432 162.65 308.053 162.65 257.082V257.082V257.082Z",
    fill: "url(#paint0_linear_2702_578)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M479.364 146.373L342.279 186.588C342.279 186.588 321.59 156.238 277.128 146.373C315.698 146.168 479.364 146.373 479.364 146.373V146.373V146.373Z",
    fill: "#EACA05"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M148.127 286.815C128.876 253.452 49.6807 116.709 49.6807 116.709L151.21 217.142C151.21 217.142 140.797 238.585 144.702 269.277L148.127 286.815V286.815V286.815Z",
    fill: "#DF3A32"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2702_578",
    x1: 166.078,
    y1: 166.037,
    x2: 166.078,
    y2: 343.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#86BBE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1072BA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleChrome);
export default __webpack_public_path__ + "static/media/Google Chrome.d37257e4fd1f57a382e297a74a566225.svg";
export { ForwardRef as ReactComponent };